import { Container } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { PageLoader } from '@/components/feedback/PageLoader';
import { useSessionExpiryRedirect } from '@/features/auth';
import { useOutstandingSocket } from '@/features/outstanding';
import { ToastHost } from '@/features/ui';

import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import { BottomNav } from './BottomNav';
import { SideNav } from './SideNav';

export const AppShell = () => {
  // Mounted here and nowhere else: two listeners would fire two navigations.
  useSessionExpiryRedirect();
  // Same reasoning — one socket for the app, opened behind the auth guard so it
  // never connects without a session.
  useOutstandingSocket();

  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <AppHeader />

      <div className="flex min-h-0 flex-1">
        <SideNav />

        {/* min-w-0 stops a wide table or long unbroken string from forcing the
            whole page to scroll sideways on a phone. */}
        {/* A column, so the footer can be pushed to the bottom of a short page
            rather than floating under the last card halfway up the screen. */}
        <main id="main" className="flex min-w-0 flex-1 flex-col pb-bottom-nav md:pb-8">
          <Container
            maxWidth="lg"
            className="flex min-h-full flex-1 flex-col px-4 py-4 md:px-6 md:py-8"
          >
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>

            {/* `mt-auto` takes up the slack: at the end of a long page it is
                just the next block, and on a short one it sits on the floor. */}
            <AppFooter className="mt-auto pt-6 pb-2" />
          </Container>
        </main>
      </div>

      <BottomNav />
      <ToastHost />
    </div>
  );
};
